import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

import { map, timeout } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class FormResponseService {

	dataInfo;

	constructor() { }

	setDataInfo(data) {
		this.dataInfo = data;
	}

	getDataInfo() {
		return this.dataInfo;
	}

	getRadicado() {
		if (this.dataInfo 
			&& this.dataInfo.info 
			&& this.dataInfo.info.radicado) {
			return this.dataInfo.info.radicado
		}
		return '';
	}

	getTitle() {
		if (this.dataInfo 
			&& this.dataInfo.info 
			&& this.dataInfo.info.title) {
			return this.dataInfo.info.title
		}
		return '';
	}

	getStatus() {
		let res = {
			valid: 0,
			invalid: 0
		};
		let len = 0;
		if (this.dataInfo 
			&& this.dataInfo.response) {
			this.dataInfo.response.map(
				(item) => {
					len = len + 1;
					if(item.success) {
						res.valid = res.valid + 1;
					} else {
						res.invalid = res.valid + 1;
					}
				}
			);
		}

		if (res.valid == len) {
			return true;
		}

		return false;
	}

}
